<template>
	<div class="content">
		<div class="tableTit">
			<p class="tabtitBg"></p>
			<h6>组织机构信息管理</h6>
			<el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">添加机构</el-button>
			<!--<el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
			<el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button>-->

		</div>
		<div class="tabBody">
			<el-table :data="tabledata" :height="tableHeight" row-key="id" :tree-props="{children: 'children'}" border :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
				<el-table-column type="index" align='center' width="60" label="序号"></el-table-column>
				<el-table-column prop="name" align='left' label="部门名称"></el-table-column>
				<el-table-column prop="regionCode" align='center' label="部门所在的行政区划"></el-table-column>
				<el-table-column prop="telephone" align='center' label="联系方式"></el-table-column>
				<el-table-column label="操作" width="90" align="center">
					<template slot-scope="scope">
						<el-button type="success" class="tableedit" icon="el-icon-edit" circle @click="edit(scope.row,scope.$index)"></el-button>
						<el-button type="warning" class="tableedit" icon="el-icon-delete" circle @click="deletes(scope.row,scope.$index)"></el-button>
					</template>
				</el-table-column>

			</el-table>

		</div>
		<!--<div class="fye">
			<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
		</div>-->

		<orgpopup v-if="dialogVisible == true" :mystate="Addsid" @getcancel="getCancel" @adddata="Adddata" @bjadddata="Bjadddata"></orgpopup>
	</div>
</template>

<script>

	//import pagintion from '@/components/mangement/pagintion.vue';

	import orgpopup from './popup/orgpopup.vue';
	import { orglist, orgdelete } from "@/api/api";

	export default {
		data() {
			return {
				tabledata: [],
				tableHeight: window.innerHeight - 180,
				total: 0,
				pageSize: 20, //每页多少条数据分页
				pageNum: 1, //当前页
				pageNums: null,
				username: '',
				dw: '',
				dialogVisible: false,
				Addsid: [],
				row: null,
			}
		},
		components: {

			//pagintion,
			orgpopup
		},
		mounted() {

			this.list();
		},
		methods: {
			list() {
				orglist().then((res) => {
					console.log(res)

					this.tabledata = res.data;
				})

			},
			getCancel() {
				this.dialogVisible = false;
			},
			addClick() {
				this.dialogVisible = true;
				this.Addsid = ["xz"];
			},
			Adddata() {
        this.dialogVisible = false;
				this.list();
			},
			Bjadddata() {
				this.dialogVisible = false;
				this.list();
			},

			DsyData(data) { //多少页
				this.pageNum = data.dsy;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
				}
			},
			DstData(data) { //多少条
				this.pageSize = data.dst;
				let params = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,

				}

			},
			reset() {

			},
			edit(row, index) {
				this.dialogVisible = true;
				this.Addsid = ["bj", row];
			},
			deletes(row, index) {
				this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(action => {
					if(action === 'confirm') {

						let params = {
							id: row.id
						};
						orgdelete(params, this.tokens, row.id).then((res) => {
							if(res.code == 200) {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});

								this.list();

							} else {
								this.$notify({
									title: "提示",
									message: res.message,
									type: "success",
								});
							}

						})
					}
				}).catch(() => {

					this.$message({
						message: '已取消',
						type: 'warning'
					});
				});
			},

		}
	}
</script>

<style scoped>
	>>>.el-input__inner {
		height: 30px;
		line-height: 30px;
		color: #606266;
		font-size: 14px;
	}
</style>
